import HotelImageSrc from '../../../assets/images/promos/hotel-image-2x.jpg'
import HotelTabletImageSrc from '../../../assets/images/promos/hotel-image-tablet-2x.jpg'

const CONTENT = {
  headline: '10% off coupon',
  subheadline:
    'Book anything today and get 10% off your next Express Deal® Hotel',
  disclaimer: 'Coupon emailed after trip.',
  boxLink: null,
  desktopImage: HotelImageSrc,
  desktopImageWebP: `${HotelImageSrc}?format=webp`,
  tabletImage: HotelTabletImageSrc,
  tabletImageWebP: `${HotelTabletImageSrc}?format=webp`,
  ariaLabel: 'Incredible Tile Promo',
  googleAnalyticsTrackingOnView: {
    action: null,
    category: null,
    label: null
  },
  googleAnalyticsTrackingOnClick: {
    category: 'promotion',
    action: 'weekly-2021',
    label: 'HOMEPAGE|promo-right|inc-tile-default'
  },
  borderTopColor: null
}

export default CONTENT
